import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { UI_PRIMITIVE__input } from '@/components/ui/UI_PRIMITIVE__input';
import i18n_base_ui from '@/locales/keys/i18n_base_ui.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  workspaceName: string;
  onConfirm: (toastId: string) => void;
  onCancel: (toastId: string) => void;
}

export function TransferOwnershipToastActions({ workspaceName, onConfirm, onCancel }: Props) {
  const { t } = useTranslation(ENUM__i18n_namespace.BASE_UI);

  const [input_value, set_input_value] = useState('');

  return (
    <div className="flex flex-col">
      <span className="text-danger text-sm">{t(i18n_base_ui.toasts.transfer_ownership_create.actions.title)}</span>
      <UI_PRIMITIVE__input
        value={input_value}
        maxLength={workspaceName.length}
        placeholder=""
        onChange={e => set_input_value(e.target.value)}
        className="mt-3 cursor-text w-full h-10 bg-component border border-component-border hover-animation duration-300 rounded-lg !outline-none focus:outline-none px-3 md:text-base !text-component-item-foreground placeholder-component-item-foreground bg-component"
      />
      <div className="flex items-center justify-between gap-4 mt-2">
        <UI_PRIMITIVE__button
          variant="outline-on-bar"
          className="!text-component-item-foreground w-full !text-danger"
          onClick={e => onConfirm(e.currentTarget.closest('[data-reach-toast]')?.id || '')}
          disabled={input_value.trim().toLowerCase() !== workspaceName.trim().toLowerCase()}
        >
          {t(i18n_base_ui.toasts.transfer_ownership_create.actions.button.transfer_ownership)}
        </UI_PRIMITIVE__button>
        <UI_PRIMITIVE__button
          variant="outline-on-bar"
          className="!text-component-item-foreground w-full"
          onClick={e => onCancel(e.currentTarget.closest('[data-reach-toast]')?.id || '')}
        >
          {t(i18n_base_ui.toasts.transfer_ownership_create.actions.button.cancel)}
        </UI_PRIMITIVE__button>
      </div>
    </div>
  );
}
